"use strict";


(function (global) {
 
    /**  
   * Фабрика документов.
   * Предоставлет инструменты для работы с документами. Например, для создания документа из шаблона.
   *
   * @namespace WebAccess.factories.eDocuments
   * @property {OBJECT_TYPE} WebAccess.factories.eDocuments.contentType Тип содержимого фабрики
   * @since 5.0.0.7300
   */

  var EDocumentsFactory = global.factories.BaseFactory.extend({
    className: "EDocumentsFactory",

    contentType: OBJECT_TYPE.EDOCUMENT,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function () {
      this._super(this.contentType);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**        
    * Получить документ по его ИД.
    * Если документ не существует, будет вызван метод fail.
    *
    * @method WebAccess.factories.eDocuments.getDocumentByID    
    * @param {Integer} id ИД документа
    * @param {MODEL} [opt_modelType] Тип возвращаемой модели данных
    * @return {Deferred} Искомый документ.
    * @since 5.0.0.7300
    *
    * @example <caption>Проверить, что документ существует, и получить его реквизиты.</caption>
    * WebAccess.factories.eDocuments.getDocumentByID().done(function(document) {
	  *   console.log('Документ существует')
    * }).fail(function(error) {
    *  console.log('Не удалось найти документ с указанным id');
	  *  console.log(error);    
    * });
    */
    getDocumentByID: function (id, opt_modelType) {
      return this.getObjectByID(id, opt_modelType);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Создать документ из шаблона.
    *
    * @method WebAccess.factories.eDocuments.createNewFromTemplate
    * @param {String} typeCode Код типа карточки документа
    * @param {String} kindCode Код вида документа
    * @param {TemplateCode} Код шаблона
    * @since 5.0.0.7300
    *
    * @example  <caption>Создать документ из шаблона.</caption>
    * WebAccess.factories.eDocuments.createNewFromTemplate('ПКО', 'Г000034', 'Д000019').done(function(document) {
    *   document.open()
    * });
    *
    * @example  <caption>Создать документ из шаблона, предварительно заполнив реквизиты документа.</caption>
    * WebAccess.factories.eDocuments.createNewFromTemplate({
    *   typeCode: 'ПКО',
    *   kindCode: 'Г000034',
    *   templateCode: 'Д000019',
    *   requisites: {
    *     'ISBEDocName': 'Новый', 
    *     'Дополнение3': 'Тема'
    *   },
    *   bindTo: new WA.Link(133475, OBJECT_TYPE.EDOCUMENT),
    *   pasteToFolder: "-1", // Если указан неизвестный ИД папки, документ будет перемещен в предопределенную папку «Избранное».
    *   autoSave: true,  
    * }).done(function(document) {
    *   document.open()
    * });
    */
    createNewFromTemplate: function (typeCode, kindCode, templateCode, opt_modelType) {
      var me = this;
      var params = {};
      var proxyCall = $.Deferred();      
      opt_modelType = (!opt_modelType) ? MODEL.FULL : opt_modelType;

      if ($.isPlainObject(typeCode)) {
        params = typeCode;

        if (typeCode.hasOwnProperty('requisites')) {
          params.requisites = $.toJSON(typeCode.requisites);
        }
        if (typeCode.hasOwnProperty('bindTo')) {
          params.bindTo = typeCode.bindTo.asString();
        }
      } else {
        if (arguments.length < 3) {
          WA.raise('ERR_NOT_ALL_REQUIRED_ARGUMENTS_HAVE_BEEN_SUPLIED');
        }
        params = {
          typeCode: typeCode,
          kindCode: kindCode,
          templateCode: templateCode
        };
      };

      WA.SRV.call("/Factories.asmx/CreatePreConfiguredEDocumentFromTemplate", {
        Params: params,
        Mode: opt_modelType
      }).done(function (model) {
        proxyCall.resolve(me._handleModel(model, opt_modelType));
      }).fail(function (error) {
        proxyCall.reject(error);
      });;
      return proxyCall;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });


  global.factories.eDocuments = new EDocumentsFactory();
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  
})(window.WebAccess);